module.exports = __webpack_public_path__ + "assets/yoast-seo.e645ab0f.svg";